export const MAX_AMOUNT = 999_999_999;
